import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { JobRFQSupplierResponseRecordView } from 'domains/jobconfigDomain';
import workspaceService from 'services/jobService';
import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from 'components/RevxDate';
import { DEFAULT_PLACEHOLDER } from 'utils/constants';
import { useAppDispatch } from 'app/hooks';

type Props = {
  rfqId?: number;
};

const TabSupplierResponseRecord: React.FC<Props> = ({ rfqId }) => {
  const dispatch = useAppDispatch();
  const [dataSource, setDataSource] = useState<JobRFQSupplierResponseRecordView[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!rfqId) return;
    const fetchData = async () => {
      try {
        setLoading(true);
        dispatch.app.showLoading();
        const res = await workspaceService.getJobRfqSupplierResponseRecordViewer(rfqId);
        if (Array.isArray(res)) {
          setDataSource(res);
        } else if (res) {
          setDataSource([res]);
        }
      } catch (e) {
        console.error('[TabSupplierResponseRecord] fetch error:', e);
      } finally {
        setLoading(false);
        dispatch.app.hideLoading();
      }
    };
    fetchData();
  }, [rfqId, dispatch]);

  const columns: ColumnsType<JobRFQSupplierResponseRecordView> = [
    {
      title: 'RFQ ID',
      dataIndex: 'rfqId',
      width: 80,
      render: (value) => value ?? DEFAULT_PLACEHOLDER,
    },
    {
      title: 'Supplier',
      dataIndex: 'supplierOrgName',
      width: 150,
      render: (value) => value ?? DEFAULT_PLACEHOLDER,
    },
    {
      title: 'Response Time',
      dataIndex: 'responseTime',
      width: 150,
      render: (value) =>
        value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : DEFAULT_PLACEHOLDER,
    },
    {
      title: 'Qty',
      dataIndex: 'quantity',
      width: 80,
      render: (value) => value ?? DEFAULT_PLACEHOLDER,
    },
    {
      title: 'Printing Cost',
      dataIndex: 'revxPrintingCharge',
      width: 120,
      render: (value) => (value != null ? `$${value}` : DEFAULT_PLACEHOLDER),
    },
    {
      title: 'Freight Cost',
      dataIndex: 'revxFreightCost',
      width: 120,
      render: (value) => (value != null ? `$${value}` : DEFAULT_PLACEHOLDER),
    },
    {
      title: 'Total Charge',
      dataIndex: 'revxCharge',
      width: 120,
      render: (value) => (value != null ? `$${value}` : DEFAULT_PLACEHOLDER),
    },

    {
      title: 'Ready Date',
      dataIndex: 'readyDate',
      width: 120,
      render: (value) =>
        value ? moment(value).format(DEFAULT_DATE_FORMAT) : DEFAULT_PLACEHOLDER,
    }
  ];

  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      loading={loading}
      pagination={false}
      rowKey={(record, index) => `${record.supplierOrgId}-${record.qtySerialNumber}-${index}`}
      scroll={{ x: 'max-content' }}
    />
  );
};

export default TabSupplierResponseRecord;
